'use strict';

var chunk33IWXYMJ_js = require('./chunk-33IWXYMJ.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var c = require('react');
var T = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var c__default = /*#__PURE__*/_interopDefault(c);
var T__default = /*#__PURE__*/_interopDefault(T);

var d=T__default.default.p`
  font-size: ${({$fontSize:t})=>t};
  font-weight: ${({$weight:t})=>t};
  line-height: ${({$lineHeight:t})=>t};
  color: ${({$color:t})=>t};
  margin: 0;
  padding: 0;
  text-align: ${({$align:t})=>t};
  text-transform: ${({$transform:t})=>t};
  text-decoration: ${({$strikeThrough:t})=>t?"line-through":"none"};
`,k=({children:t,as:i="p",color:s="",size:l="400",fontWeight:f="regular",align:g="left",transform:a="none",ellipsis:$=!1,strikeThrough:m=!1})=>{let{tokens:p}=chunkHUKGHOBJ_js.b(),e=chunk33IWXYMJ_js.a(l),x=chunk33IWXYMJ_js.b(f),h=`${i}`;return c__default.default.createElement(d,{as:h,$color:s||p.text_default_text_primary,$weight:x,$align:g,$transform:a,$fontSize:e.fontSize,$lineHeight:e.lineHeight,$ellipsis:$,$strikeThrough:m},t)};

exports.a = k;
